module.exports = __webpack_public_path__ + "h5/img/usdt.99bd1f55.png";